<template>
  <div class="recommend">
    <NavBar title="" rightText="" @clickRight="onClickRight" @clickLeft="onClickLeft"></NavBar>
    <img src="../assets/imgs/logo.png" class="recomLogo" />
    <p>- 欢迎使用麻城公交APP -</p>
    <div class="main">
      <p class="box" ref="qrCodeUrl" id="qr"></p>
    </div>
    <h2 class="opticy">
      <h1 @click="down">
        <span>保存图片至本地</span>
      </h1>
    </h2>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar";
import QRCode from "qrcodejs2";
import getParams from "@/utils/getQuery";

export default {
  components: { NavBar },
  data() {
    return {};
  },

  mounted() {
    getParams();
    this.$nextTick(() => {
      this.createCode();
    });
  },

  methods: {
    onClickRight() {
      this.$router.push("/statistics");
    },
    onClickLeft() {
      console.log("点了左边");
    },
    createCode() {
      var userId = sessionStorage.getItem("userId");
      let location = window.location
      new QRCode(this.$refs.qrCodeUrl, {
        text: `${location.protocol}//${location.host}${location.pathname}#/register?userId=${userId}`,
        width: 190,
        height: 180,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H,
      });
    },
    down() {
      var u = navigator.userAgent,
        isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1,
        isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      if (isiOS) {
        let myCanvas = document
          .getElementById("qr")
          .getElementsByTagName("canvas");
        let a = document.createElement("a");
        // a.href = myCanvas[0].toDataURL("image/png");
        a.href = "recommendPage";
        a.download = "麻城公交分享二维码";
        console.log(a);
        a.click();
      } else if (isAndroid) {
        window.cqck.saveImage();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.recommend {
  position: absolute;
  width: 100%;
  height: 100%;
  background: linear-gradient(0deg, #58A1A7, #86C3C4);
  display: flex;
  flex-direction: column;
  align-items: center;

  .recomLogo {
    width: 90px;
    height: 90px;
    margin-top: 20px;
  }

  >p {
    font-size: 21px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #ffffff;
    line-height: 21px;
  }

  .main {
    background-image: url("../assets/imgs/qrCode.png");
    background-size: 100%;
    background-repeat: no-repeat;
    width: 261px;
    height: 308px;
    z-index: 99;
    display: flex;
    justify-content: center;

    .box {}
  }

  h1 {
    width: 208px;
    height: 45px;
    background: #FFFF00;
    box-shadow: 0px 0px 29px 0px rgba(6, 0, 1, 0.2);
    border-radius: 22px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-bottom: 80px;

    .qrLogo {
      width: 24px;
      height: 24px;
    }

    span {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 200;
      color: #333333;
    }
  }

  .opticy {
    width: 100%;
    background: url("../assets/imgs/opticy.png");
    background-size: 100%;
    position: fixed;
    bottom: 0;
    height: 200px;
    display: flex;
    justify-content: center;
    align-items: flex-end;
  }
}
</style>